import React from 'react'
import { CircleProps } from './interface'
import { CircleLabel, CircleTag, InlineText } from './style'

const Circle: React.FC<CircleProps> = ({ children, color = 'white', borderColor, small }) => (
  <InlineText>
    <CircleTag color={color} borderColor={borderColor} small={small} />
    <CircleLabel>{children}</CircleLabel>
  </InlineText>
)

export default Circle
